import { useQuery } from '@tanstack/react-query';
import { USERS_ME_QUERY_KEY, USERS_QUERY_KEY } from '@/constants/react_query_keys';
import { getMe } from '@/services/user';
import { api } from '@/utils/api';

export function useGetCurrentUser() {
  return useQuery({
    queryKey: [USERS_QUERY_KEY, USERS_ME_QUERY_KEY],
    queryFn: () => getMe(),
    enabled:
      api.defaults.headers.authorization !== undefined &&
      api.defaults.headers.authorization !== null,
    retry: 1,
    refetchInterval: 1000 * 60 * 5, // 5 minutes
    refetchOnWindowFocus: 'always'
  });
}
